import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getReferralInitialValues } from './utils';

import type { RootState } from '../../../../../../../store';

export default function useReferralInitialValues() {
  const referralInfo = useSelector(
    (state: RootState) =>
      state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.referral,
  );

  return useMemo(() => getReferralInitialValues(referralInfo), [referralInfo]);
}
